export const shortlistTranslations = {
  en: {
    "shortlist.title": "Your shortlist",
    "shortlist.nav": "Saved flights ({count})",
    "shortlist.save": "Save flight",
    "shortlist.remove": "Remove flight",
    "shortlist.saved": "Saved",
    "shortlist.night": "1 night",
    "shortlist.nights": "{count} nights",
    "shortlist.options": "Sharing options",
    "shortlist.empty": "Your next trip starts here",
    "shortlist.emptyHint": "Save flights you like, then share them with friends to choose a favourite together.",
    "shortlist.share": "Share shortlist",
    "shortlist.view": "View votes",
    "shortlist.stop": "Stop sharing",
    "shortlist.stopHint": "This disables the shared link and deletes all votes. Your saved flights stay in this browser.",
    "shortlist.confirmStop": "Stop sharing and delete votes",
    "shortlist.cancel": "Cancel",
    "shortlist.close": "Close shortlist",
    "shortlist.limit": "You can save up to 20 flights. Remove one to save another.",
    "shortlist.storageError": "Allow browser storage to keep your flights, vote and creator access.",
    "shortlist.saveError": "Could not save your change. Check your connection and try again.",
    "shortlist.shareError": "Could not share these flights. Check your connection and travel dates, then try again.",
    "shortlist.loadError": "Could not load the shortlist. Please try again.",
    "shortlist.expired": "Your shared link has expired or was deleted. Your saved flights are still here.",
    "shortlist.expiry": "This link and all votes expire on {date}, 30 days after the latest flight arrives.",
    "shortlist.publicTitle": "Where shall we go?",
    "shortlist.publicHint": "Pick your favourite flight. You can change your vote anytime.",
    "shortlist.vote": "Vote for this flight",
    "shortlist.yourVote": "Your vote",
    "shortlist.votes": "{count} votes",
    "shortlist.totalVotes": "{count} votes so far",
    "shortlist.popular": "Most popular",
    "shortlist.voteError": "Could not save your vote. Refresh the list and try again.",
    "shortlist.refresh": "Refresh results",
    "shortlist.retry": "Try again",
    "shortlist.unavailable": "This shortlist is unavailable",
    "shortlist.unavailableHint": "The link is invalid, has expired, or the creator stopped sharing it.",
    "shortlist.sharedEmpty": "The creator is updating this shortlist. Check back soon.",
    "shortlist.manage": "You created this shortlist. Add flights from search or remove them here.",
    "shortlist.priceHint": "Saved fares may change. Check current prices with the provider before booking.",
    "shortlist.loading": "Loading shortlist …",
    "shortlist.working": "Saving …",
  },
  de: {
    "shortlist.title": "Deine Merkliste",
    "shortlist.nav": "Gemerkte Flüge ({count})",
    "shortlist.save": "Flug merken",
    "shortlist.remove": "Flug entfernen",
    "shortlist.saved": "Gemerkt",
    "shortlist.night": "1 Nacht",
    "shortlist.nights": "{count} Nächte",
    "shortlist.options": "Freigabe verwalten",
    "shortlist.empty": "Deine nächste Reise beginnt hier",
    "shortlist.emptyHint": "Merke dir spannende Flüge und teile sie mit Freunden, um gemeinsam euren Favoriten zu wählen.",
    "shortlist.share": "Merkliste teilen",
    "shortlist.view": "Abstimmung ansehen",
    "shortlist.stop": "Teilen beenden",
    "shortlist.stopHint": "Der Link wird deaktiviert und alle Stimmen werden gelöscht. Deine gemerkten Flüge bleiben in diesem Browser.",
    "shortlist.confirmStop": "Teilen beenden und Stimmen löschen",
    "shortlist.cancel": "Abbrechen",
    "shortlist.close": "Merkliste schließen",
    "shortlist.limit": "Du kannst bis zu 20 Flüge merken. Entferne einen, um einen weiteren zu speichern.",
    "shortlist.storageError": "Erlaube Browser-Speicher für deine Flüge, Stimme und den Zugriff als Ersteller.",
    "shortlist.saveError": "Änderung konnte nicht gespeichert werden. Prüfe deine Verbindung und versuche es erneut.",
    "shortlist.shareError": "Flüge konnten nicht geteilt werden. Prüfe Verbindung und Reisedaten und versuche es erneut.",
    "shortlist.loadError": "Die Merkliste konnte nicht geladen werden. Bitte erneut versuchen.",
    "shortlist.expired": "Dein Link ist abgelaufen oder wurde gelöscht. Deine gemerkten Flüge sind noch da.",
    "shortlist.expiry": "Link und Stimmen verfallen am {date}, 30 Tage nach der letzten Flugankunft.",
    "shortlist.publicTitle": "Wohin fliegen wir?",
    "shortlist.publicHint": "Wähle deinen Lieblingsflug. Du kannst deine Stimme jederzeit ändern.",
    "shortlist.vote": "Für diesen Flug stimmen",
    "shortlist.yourVote": "Deine Stimme",
    "shortlist.votes": "{count} Stimmen",
    "shortlist.totalVotes": "Bisher {count} Stimmen",
    "shortlist.popular": "Am beliebtesten",
    "shortlist.voteError": "Deine Stimme konnte nicht gespeichert werden. Aktualisiere die Liste und versuche es erneut.",
    "shortlist.refresh": "Ergebnisse aktualisieren",
    "shortlist.retry": "Erneut versuchen",
    "shortlist.unavailable": "Diese Merkliste ist nicht verfügbar",
    "shortlist.unavailableHint": "Der Link ist ungültig, abgelaufen oder wird nicht mehr geteilt.",
    "shortlist.sharedEmpty": "Die Merkliste wird gerade überarbeitet. Schau bald wieder vorbei.",
    "shortlist.manage": "Du hast diese Merkliste erstellt. Füge Flüge aus der Suche hinzu oder entferne sie hier.",
    "shortlist.priceHint": "Gemerkte Preise können sich ändern. Prüfe aktuelle Preise vor der Buchung beim Anbieter.",
    "shortlist.loading": "Merkliste laden …",
    "shortlist.working": "Wird gespeichert …",
  },
};
